import { createContext, useContext } from 'react';

import { SidebarCardKey } from '../../conversationSidebar.types';

/**
 * Per-card context provided by the flat `sidebar-cards-admin-management`
 * renderer around each rendered card. It lets the shared `CardMoveHandle` and
 * `VisibilityToggle` — which are embedded inside the individual card components
 * — source their visibility state from the flat model instead of the legacy
 * per-section `useCardSectionVisibility` hook, without having to rewire every
 * card's JSX. Absent (`null`) on the legacy sectioned path.
 */
export type FlatCardContextValue = {
  readonly cardKey: SidebarCardKey;
  /** Hidden for any reason (org, user, or conditions) — used to disable drag. */
  readonly isHidden: boolean;
  /**
   * Hidden by the org default or the agent's own choice, ignoring conditions —
   * what the visibility toggle's icon reflects.
   */
  readonly isUserHidden: boolean;
  /** Hidden because its conditions didn't match — surfaced as a tooltip. */
  readonly isConditionHidden: boolean;
  readonly toggleVisibility: () => void;
};

export const FlatCardContext = createContext<FlatCardContextValue | null>(null);

export const useFlatCardContext = (): FlatCardContextValue | null =>
  useContext(FlatCardContext);
